module.exports = __webpack_public_path__ + "img/cuo@2x.730d0fa0.png";